import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';
import App from './App';
import store from './store';
import { setStore } from './api/apiClient';
import AuthProvider from './components/AuthProvider';

// Set store reference for API client
setStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AuthProvider>
      <BrowserRouter
      //  basename={process.env.REACT_APP_BASE_PATH || "/almata"}
       >
        <App />
        <ToastContainer position="top-right"  style={{ width: "320px" }}
        toastStyle={{ paddingRight: "40px" }} autoClose={3000} />
      </BrowserRouter>
    </AuthProvider>
  </Provider>
);